import React from 'react';
import { ASSETS } from '../../config/Config';

// O segredo: Este componente NUNCA re-renderiza (retorna true na comparação).
export const HeaderLogo = React.memo(() => {
  return (
    <div className="flex items-center gap-3 w-full h-full select-none pointer-events-none">
        {/* ÍCONE - AUMENTADO EM 30% */}
        <img 
            src={ASSETS.logoIcon} 
            alt="Logo Ícone" 
            width="32"
            height="32"
            className="h-6 md:h-8 w-auto aspect-square object-contain block"
            loading="eager"
            decoding="async" 
        />
        
        {/* NOME - AUMENTADO EM 30% */}
        <img 
            src={ASSETS.logoName} 
            alt="Rodrigo Demeterco" 
            width="160"
            height="16"
            className="h-[12px] md:h-[16px] w-auto object-contain block mt-1"
            loading="eager"
            decoding="async"
        />
    </div>
  );
}, () => true);

export const FooterLogo = React.memo(() => {
    return (
        <div className="flex items-center gap-2 mb-4 select-none">
            <img 
              src={ASSETS.logoIcon}
              alt="Logo"
              className="h-7 w-7 aspect-square object-contain opacity-90 block"
              loading="lazy"
            />
            <img 
              src={ASSETS.logoName}
              alt="Nome"
              className="h-4 w-auto object-contain opacity-90 block mt-1"
              loading="lazy"
            />
        </div>
    );
}, () => true);